import { GAME_ID, REDUX_ACTIONS, SCREENS } from '../../data/constants';

const initialState = {
  levelIndex: null,
  trapForLevel: null,
  itemIndex: null, // the index in the current level's "items" array to pull content from.
};

const curriculumReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_LEVEL:
      return {
        ...state,
        levelIndex: payload.levelIndex,
        trapForLevel: payload.trapForLevel,
      };

    case REDUX_ACTIONS.SELECT_CLUE:
      return {
        ...state,
        itemIndex: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      if (payload === SCREENS.ROOM_VIEW) return { ...state, itemIndex: null };
      return state;

    default:
      return state;
  }
};

export default curriculumReducer;
